import React from 'react';

import getColor from '../../../utils/getColor';
import styles from './styles/button-radius-5.module.css';

export default function ButtonRadius5({ width, height, fontSize, iconSize, status, icon, text, handleClick }) {
    const size = iconSize || '20px';

    return (
        <button
            className={styles.wrapper}
            style={{ width, backgroundColor: getColor(status), fontSize }}
            data-type={height}
            data-status={handleClick ? status : 'inactive'}
            onClick={status === 'inactive' ? null : handleClick}
        >
            {icon &&
                <div style={{ width: size, height: size, color: '#FFF' }}>
                    {icon}
                </div>
            }
            {text}
        </button>
    );
}
